export const MAIN_CALCULATOR_ELEMENT_ID = "main-calculator";
export const LANDING_PHONE_NUMBER_STORAGE_KEY = "landing.phoneNumber";
export const LANDING_LOCALE_STORAGE_KEY = "landing.locale";
export const LANDING_URL_STORAGE_KEY = "landing.url";

export enum STAND {
  DEV = "dev",
  PROD = "prod",
}

export const PRODUCT_ID = "product_id";

export const whatsappManagerGreetingText =
  "Halo Saridana! Saya tertarik dengan produk Saridana. Boleh minta info lebih lanjut ya";
